// src/firebase.js
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB35frSR8cpUFpEcO6DneoovTUmKcEmzxM",
  authDomain: "bfg-project-c8f6f.firebaseapp.com",
  databaseURL: "https://bfg-project-c8f6f-default-rtdb.firebaseio.com",
  projectId: "bfg-project-c8f6f",
  storageBucket: "bfg-project-c8f6f.firebasestorage.app",
  messagingSenderId: "439200151438",
  appId: "1:439200151438:web:ae02dc51f449d31e9f96df",
  measurementId: "G-MTE3CP6521",

};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firebase features you need
export const storage = getStorage(app);
export const database = getDatabase(app);
export const auth = getAuth(app);
